package techla.guard

import kotlinx.serialization.Serializable
import techla.base.Key

@Serializable
data class Access(
    val service: Key<Service>,
    val role: Role,
)